module.exports = __webpack_public_path__ + "img/ico_2.32f2eb26.png";